import React from 'react'
import Button from '@softwaredev_cegeka/stix-core/dist/components/Button'
import InternalServerError from 'src/routes/InternalServerError'
import { unregister } from 'src/serviceWorkerRegistration'
import styles from './appErrorBoundary.module.scss'

class AppErrorBoundary extends React.Component {
    state = { hasError: false }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: process.env.NODE_ENV !== 'development',
        }
    }

    componentDidCatch(error, errorInfo) {
        console.error(error)
        console.log(errorInfo)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles.appErrorBoundary}>
                    <InternalServerError />
                    <p>
                        Something went very wrong. Please click the button below
                        to try again.
                    </p>
                    <Button
                        variant="secondary"
                        onClick={async () => {
                            await unregister()
                            if ('caches' in window) {
                                const keyList = await caches.keys()
                                await Promise.allSettled(
                                    keyList.map(key => {
                                        return caches.delete(key)
                                    })
                                )
                            }
                            window.location.reload()
                        }}
                    >
                        Clear cache
                    </Button>
                </div>
            )
        }
        return this.props.children ?? null
    }
}

export default AppErrorBoundary
